import { DoubleRightArrowSVG, RightArrowSVG } from '../../media/svgs'

const Pagination = ({
  totalItems,
  itemsPerPage = 5,
  visiblePages = 3,
  currentPage,
  onPageChange,
}) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage)

  const getPaginationRange = () => {
    if (totalPages <= visiblePages) {
      return Array.from({ length: totalPages }, (_, i) => i + 1)
    }

    const half = Math.floor(visiblePages / 2)
    let startPage = currentPage - half
    let endPage = currentPage + half

    if (startPage < 1) {
      startPage = 1
      endPage = visiblePages
    }

    if (endPage > totalPages) {
      endPage = totalPages
      startPage = totalPages - visiblePages + 1
    }

    return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i)
  }

  const handleClick = (page) => {
    if (page === currentPage) return
    onPageChange?.(page)
  }

  // if (totalPages <= 1) return null;

  return (
    <div className="pagination-outer-container">
      <div
        className={`pagination-step-container left-step-container ${currentPage === 1 && 'disable-actions '}`}
        onClick={() => handleClick(1)}
      >
        <DoubleRightArrowSVG width="18" height="18" />
      </div>

      <div
        className={`pagination-step-container left-step-container ${currentPage === 1 && 'disable-actions '}`}
        onClick={() => handleClick(currentPage - 1)}
      >
        <RightArrowSVG width="18" height="18" />
      </div>

      <div className="pagination-inner">
        {getPaginationRange().map((page) => (
          <button
            key={page}
            onClick={() => handleClick(page)}
            className={`pagination-page ${page === currentPage ? 'page-selected' : ''}`}
          >
            {page}
          </button>
        ))}
      </div>

      <div
        className={`pagination-step-container ${currentPage === totalPages && 'disable-actions '}`}
        onClick={() => handleClick(currentPage + 1)}
      >
        <RightArrowSVG width="18" height="18" />
      </div>

      <div
        className={`pagination-step-container ${currentPage === totalPages && 'disable-actions '}`}
        onClick={() => handleClick(totalPages)}
      >
        <DoubleRightArrowSVG width="18" height="18" />
      </div>
    </div>
  )
}

export default Pagination
